import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import LabelText from '../LabelText';

const Email = (props) => {
	const { t } = useTranslation();
	const dispatch = useDispatch();

	const {form_component} = props;

	const fv = useSelector(state => state.fv);

	const contactFields = useSelector(state => state.contactFields);
	const {email} = contactFields;

	const userData = useSelector(state => state.userData);
	const lineUserData = useSelector(state => state.lineUserData);
	const pageData = useSelector(state => state.pageData);
	const controller = pageData.controller;

	const registerField = () => {
		// For Shopcarts controller, only use global validator
		// For other controllers, use Redux store validator
		const validator = controller === 'Shopcarts' ? window.globalFormValidator : fv;
		
		if (validator) {
			var validators = {
				emailAddress: {
					message: t('電郵格式不正確')
				}
			};
			if (form_component.required) {
				validators.notEmpty = {
					message: t('此欄為必須填寫')
				};
			}
			//console.log(`validators`, validators);
			const fieldName = controller === 'Shopcarts' ? 'buyer_email' : 'email';
			
			try {
				// Check if field already exists and remove it first
				if (validator.elements && validator.elements[fieldName]) {
					validator.removeField(fieldName);
				}
				
				validator.addField(fieldName, {
					validators: validators,
					// Explicitly specify the element selector
					selector: `input[name="${fieldName}"]`
				});
			} catch (error) {
				console.error('Error registering field:', fieldName, error);
			}
		}
	};

	useEffect(() => { // to be updated after render
		registerField();
	}, [fv, controller, form_component.required, t]);

	// Listen for FormValidation reinitialization
	useEffect(() => {
		const handleReinitialization = (event) => {
			registerField();
		};

		document.addEventListener('formValidationReinitialized', handleReinitialization);
		
		return () => {
			document.removeEventListener('formValidationReinitialized', handleReinitialization);
		};
	}, [fv, controller, form_component.required, t]);

	useEffect(() => { // to be updated after render
		// Only update if we have actual data and the field is currently empty
		// This prevents clearing existing user input
		if (!email || email.trim() === '') {
			if (userData && userData.email && userData.email.trim() !== '') {
				dispatch({type: 'SET_CONTACT_FIELD', payload: {field: 'email', value: userData.email}});
			} else if (lineUserData && lineUserData.email && lineUserData.email.trim() !== '') {
				dispatch({type: 'SET_CONTACT_FIELD', payload: {field: 'email', value: lineUserData.email}});
			}
		}
	}, [lineUserData, userData, email]);

	const onChange = (e) => {
		const value = e.target.value;

		dispatch({type: 'SET_CONTACT_FIELD', payload: {field: 'email', value: value}});
		
		// Force update DOM value for FormValidation
		if (controller === 'Shopcarts') {
			const fieldName = 'buyer_email';
			const domElement = document.querySelector(`input[name="${fieldName}"]`);
			if (domElement) {
				domElement.setAttribute('value', value);
				domElement.value = value;
			}
		}
	}

	return (
		<div className={`flex-grow-1 form-group text ${form_component.required ? 'required' : ''}`}>
			<LabelText
				form_component={form_component}
			/>
			<input
				type="text"
				name={controller === 'Shopcarts' ? 'buyer_email' : 'email'}
				placeholder={form_component.default_text_type === 'placeholder' ? form_component.default_text : ''}
				className="form-control-sm mb-3 form-control"
				id={controller === 'Shopcarts' ? 'buyer-email' : 'email'}
				value={email || ''}
				onChange={onChange}
			/>
		</div>
	);
}

export default Email;